// Application layer
/**
 * Caso de uso: listar  gastos
 * ------------------------------------------------
 * Responsabilidad:
 * - Validar filtros
 * - Aplicar reglas de negocio de lectura
 * - Delegar persistencia al repositorio
 */

import { gastosRepository } from "../infrastructure/supabase/gastos.repository.js";

export async function listarGastosUseCase(filtros) {
  return await gastosRepository.listar(filtros);
}
